import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import React, { useRef } from "react";
import { IListarComprovantesUsuarioResponse } from "../../../../Interfaces/Vendas/Usuario/UsuarioInterface";
import { EventClickArg } from "@fullcalendar/react";

interface IAgendaGestaoAtividades {
    lstCompromissosUsuario: IListarComprovantesUsuarioResponse[] | undefined;
    eventClick(arg: EventClickArg): void;
}

export default function AgendaGestaoAtividades({
    lstCompromissosUsuario,
    eventClick,
}: IAgendaGestaoAtividades) {
    const calendarRef = useRef<FullCalendar>(null);
    // const [dateRange, setLocalDateRange] = useState({
    //     DATA_INICIO: "",
    //     DATA_FIM: "",
    // });

    // useEffect(() => {
    //     const calendarApi = calendarRef.current?.getApi();
    //     if (calendarApi) {
    //         const start = calendarApi.view.activeStart;
    //         const end = calendarApi.view.activeEnd;

    //         const newDateRange = {
    //             DATA_INICIO: String(start),
    //             DATA_FIM: String(end),
    //         };

    //         if (
    //             newDateRange.DATA_INICIO !== dateRange.DATA_INICIO ||
    //             newDateRange.DATA_FIM !== dateRange.DATA_FIM
    //         ) {
    //             setLocalDateRange(newDateRange);
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    // const handleDatesSet = (arg: any) => {
    //     const newDateRange = {
    //         DATA_INICIO: String(arg.start),
    //         DATA_FIM: String(arg.end),
    //     };

    //     if (
    //         newDateRange.DATA_INICIO !== dateRange.DATA_INICIO ||
    //         newDateRange.DATA_FIM !== dateRange.DATA_FIM
    //     ) {
    //         setLocalDateRange(newDateRange);
    //     }
    // };

  
    return (
        <div className="px-3 pb-3">
            <FullCalendar
                ref={calendarRef}
                plugins={[
                    dayGridPlugin,
                    timeGridPlugin,
                    bootstrapPlugin,
                    interactionPlugin,
                ]}
                initialView="dayGridMonth"
                events={lstCompromissosUsuario?.map((compromisso) => ({
                    id: String(compromisso.ID_ATIVIDADE),
                    title: compromisso.DS_TIPO_ATIVIDADE,
                    start: compromisso.DT_CASO_ATIVIDADE,
                }))}
                height="auto"
                contentHeight="auto"
                themeSystem="bootstrap"
                locale="pt-br"
                eventClick={eventClick}
                // datesSet={handleDatesSet}
                locales={[
                    {
                        code: "pt-br",
                        allDayText: "Dia Todo",
                        buttonText: {
                            day: "Dia",
                            month: "Mês",
                            today: "Hoje",
                            week: "Semana",
                        },
                    },
                ]}
                expandRows={true}
                eventMaxStack={2}
                slotEventOverlap={false}
                headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
            />
        </div>
    );
}
